<template>
  <div class="com-table_wrapper">
    <el-table
      :data="list"
      v-bind="$attrs"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
      :row-key="getRowKeys"
      ref="elTable"
    >
      <el-table-column type="selection" width="55" v-if="selection" :reserve-selection="true">
      </el-table-column>

      <af-table-column label="#" type="index" width="60"></af-table-column>
      <template v-for="item in columns">
        <template v-if="!item.hidden">
          <template v-if="item.type === 'slot'">
            <!-- 根据auto配置是否使用宽度自适应 -->
            <af-table-column
              v-if="item.auto"
              :key="item.prop"
              :label="item.label"
              :width="item.width || null"
              :min-width="item.minWidth || null"
              :fixed="item.fixed || false"
              :sortable="item.sortable || false"
              align="center"
            >
              <template slot-scope="scope">
                <slot :name="item.slotName" :data="scope.row"></slot>
              </template>
            </af-table-column>
            <el-table-column
              :key="item.prop + 1"
              v-else
              :label="item.label"
              :width="item.width || null"
              :min-width="item.minWidth || null"
              :fixed="item.fixed || false"
              :sortable="item.sortable || false"
              align="center"
            >
              <template slot-scope="scope">
                <slot :name="item.slotName" :data="scope.row"></slot>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <af-table-column
              v-if="item.auto"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :width="item.width || null"
              :min-width="item.minWidth || null"
              :fixed="item.fixed || false"
              :sortable="item.sortable || false"
              align="center"
            ></af-table-column>
            <el-table-column
              :key="item.prop + 1"
              v-else
              :prop="item.prop"
              :label="item.label"
              :width="item.width || null"
              :min-width="item.minWidth || null"
              :fixed="item.fixed || false"
              :sortable="item.sortable || false"
              align="center"
            >
            </el-table-column>
          </template>
        </template>
      </template>
    </el-table>
    <div class="flex justify-end pagination_wrapper" v-if="totals > 10">
      <el-pagination
        :total="totals"
        :current-page="query.pageIndex"
        @current-change="changeSize"
        @size-change="sizeChange"
        layout="sizes,prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import utils from 'my-tools-library'

export default {
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    api: {
      type: [Function, String],
      default: ''
    },
    params: {
      type: Object,
      default: () => {}
    },
    defaultParams: {
      type: Object,
      default: () => {}
    },
    defaultSelect: {
      type: [Array, Object],
      default: () => []
    },
    run: {
      type: Boolean,
      default: true
    },
    selection: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      totals: 0,
      loading: false,
      query: {
        pageIndex: 1,
        pageSize: 10
      },
      search_params: {},
      getRowKeys(row) {
        return row.id || row.code
      },
      currentSelection: [], // 表格选中
      selectNumber: null, // 选中条数
      selectionId: [], // 选中Id
      clientWidth: document.body.clientWidth
    }
  },
  methods: {
    init() {
      this.query = {
        pageIndex: 1,
        pageSize: 10
      }

      this.getList()
    },
    // 弃用
    handleSearch(e) {
      this.search_params = e
      this.init()
    },
    search(e) {
      this.search_params = e
      this.init()
    },

    getList() {
      this.loading = true

      // 默认参数处理
      if (this.defaultParams && Object.keys(this.defaultParams).length) {
        this.query = { ...this.query, ...this.defaultParams }
      }

      // 搜索参数处理
      if (Object.keys(this.search_params).length) {
        this.query = { ...this.query, ...this.search_params }
      }

      // 传参处理
      if (this.params && Object.keys(this.params).length) {
        this.query = { ...this.query, ...this.params }
      }
      console.log('query :>> ', this.query)
      this.api(utils.cleanObject(this.query))
        .then((res) => {
          const {
            records,
            pager: { itemCount }
          } = res.data
          this.list = records
          this.totals = +itemCount
          this.loading = false
          console.log('表格数据', records)
        })
        .catch(() => {
          this.loading = false
        })
    },
    reset() {
      this.init()
    },
    changeSize(e) {
      this.query.pageIndex = e
      this.getList()
    },
    sizeChange(e) {
      this.query.pageSize = e
      this.getList()
    },
    handleSelectionChange(rows) {
      this.currentSelection = rows
      this.selectNumber = this.currentSelection.length
      this.selectionId = []
      if (rows) {
        rows.forEach((row) => {
          this.selectionId.push(row.id)
        })
      }
      this.$emit('selection-change', this.currentSelection)
    },
    handleSortChange(val) {
      this.$emit('on-sort', val)
    },

    clearSelection() {
      this.$refs.elTable.clearSelection()
    }
  },
  watch: {
    api: {
      handler(val) {
        if (val && this.run) {
          this.init()
        }
      },
      deep: true,
      immediate: true
    },
    list: {
      handler(val) {
        if (val.length) {
          if (this.defaultSelect.length) {
            this.defaultSelect.forEach((child) => {
              val.forEach((item, index) => {
                if (child.refStore === item.code) {
                  this.$nextTick(() => {
                    this.$refs.elTable.toggleRowSelection(val[index], true)
                  })
                }
              })
            })
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    console.log('update :>>更新 ')
    window.onresize = () => {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.com-table_wrapper {
  .pagination_wrapper {
    margin-top: 10px;
  }
  .created-btn {
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss">
.el-table .cell {
  padding: 0 15px !important;
}
</style>
